import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'note-box',
  templateUrl: './note-box.component.html',
  styleUrls: ['./note-box.component.scss'],
})
export class NoteBoxComponent implements OnInit {
  @Input() countries: any[];
  context: string;
  private isGlobal: boolean;

  constructor() {}

  ngOnInit(): void {
    if (this.countries.length === 0) return;

    this.isGlobal = this.countries.some((country) => country.code === 'GLC');

    if (this.isGlobal) {
      this.context = 'The gift card is available in all countries.';
    } else {
      const countryNames = this.countries
        .map((country) => country.name)
        .reduce(
          (a, b, i, array) => a + (i < array.length - 1 ? ', ' : ' and ') + b
        );
      this.context = `The gift card is only available in the ${countryNames}`;
    }
  }
}
